import Audio from '@/components/common/customAudio';
import { CloseOutlined, LinkOutlined } from '@ant-design/icons';
import { Modal } from 'antd';
import moment from 'moment';
import { useState } from 'react';

const AssessmentFileList = ({ loading, files }) => {
  const [visible, setVisible] = useState(false);
  const [file, setFile] = useState('');
  const handleOpen = (data) => {
    setFile(data?.file);
    setVisible(true);
  };
  const closeModal = () => {
    setVisible(false);
  };
  return (
    <>
      <Modal
        className="landing-video"
        closable={false}
        width={960}
        visible={visible}
        footer={null}
        onCancel={closeModal}
        bodyStyle={{ padding: 0, width: '100%', height: '100%' }}
      >
        <CloseOutlined
          rev=""
          className="video-close-btn cursor-pointer"
          onClick={closeModal}
          title="Close Video"
        />
        <div className="landing-video-wrapper">
          <iframe
            id="learnsic-course-enrol"
            className="learnsic-course-enrol"
            src={`${file}#toolbar=0`}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
            allowFullScreen
          ></iframe>
        </div>
      </Modal>
      <div className="attachments-section">
        <div className="d-flex">
          <LinkOutlined
            rev=""
            className="font-weight-bold"
            style={{ fontSize: '18px' }}
          />
          <div className="m-0 font-weight-bold ml-2 text-dark">Attachments</div>
        </div>
        <div className="attachments-list mt-3 mb-3">
          {!loading &&
            files?.map((each, idx) =>
              each?.file_type !== 'voice' ? (
                <div
                  className="attachment-item row mt-3"
                  key={idx}
                  onClick={() => handleOpen(each)}
                >
                  <div className="col-lg-6 p-3">
                    <a className="item-preview">
                      <span className="item-text">
                        {each?.file?.split('.').pop()}
                      </span>
                    </a>
                  </div>
                  <div className="col-lg-6 p-3">
                    <p className="item-details d-flex flex-column">
                      <span className="item-name">{each?.file_name}</span>
                      <small className="item-other-details">
                        Added {moment(each?.created_at).fromNow()}
                      </small>
                    </p>
                  </div>
                </div>
              ) : (
                <Audio source={each?.file} key={idx} />
              )
            )}
        </div>
      </div>
    </>
  );
};

export default AssessmentFileList;
